import { Button } from "@patient-watch/ui/button";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@patient-watch/ui/dialog";
import { useState } from "react";

import { toInputRow } from "../../features/dictionaries/attachDictionaryRows";
import { useUpdateInput } from "../../features/forms/api/upsertInput";
import { InputT } from "../../types/database/forms";
import { ui } from "@patient-watch/ui";

function AddOption(props: { input: InputT }) {
    const updateInput = useUpdateInput();
    const [newOption, setNewOption] = useState<string>("");

    // A dictionary owns its choices. Adding one here would fork the list for a single input.
    if (props.input.dictionary_id != null) {
        return (
            <Button
                size="sm"
                variant="secondary"
                disabled
                title={`Choices come from the ${props.input.dictionary?.name ?? "linked"} dictionary`}
            >
                Add Option
            </Button>
        );
    }

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button size="sm" variant="secondary">
                    Add Option
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Add Option</DialogTitle>
                </DialogHeader>
                <ui.Label className="">New Option</ui.Label>
                <ui.Input value={newOption} onChange={(e) => setNewOption(e.target.value)} />
                <DialogFooter>
                    <DialogClose>
                        <ui.Button
                            size="default"
                            onClick={() => {
                                updateInput.mutate({
                                    ...toInputRow(props.input),
                                    options: [...(props.input.options ?? []), newOption],
                                });
                                setNewOption("");
                            }}
                        >
                            Add
                        </ui.Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default AddOption;
